import React, { useState } from 'react';
import {
    Box,
    Menu,
    MenuItem,
    IconButton,
    Typography
} from '@mui/material';
import {
    MoreVert as MoreVertIcon,
    Visibility as ViewIcon,
    Cancel as CancelIcon,
    CheckCircle as CheckCircleIcon,
    CheckCircle as ApproveIcon
} from '@mui/icons-material';

import { useNavigate } from 'react-router-dom';

const BookingAction = ({
    booking,
    onStatusUpdate
}) => {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };
  
    const handleAction = (action) => {
        handleMenuClose();
            
        switch (action) {
            case 'view':
                navigate(`/bookings/${booking.id}`);
                break;
            case 'pending':
                onStatusUpdate(booking, 'pending');
                break;
            case 'confirmed':
                onStatusUpdate(booking, 'confirmed');
                break;
            case 'completed':
                onStatusUpdate(booking, 'completed');
                break;
            case 'cancelled':
                onStatusUpdate(booking, 'cancelled');
                break;
            default:
                break;
        }
    };

    const getAvailableActions = (status) => {
        // Always allow "View Details"
        const actions = [{
            key: 'view',
            label: 'View Details',
            icon: <ViewIcon />,
            color: 'primary'
        }];

        switch (status) {
            case 'draft':
                actions.push({
                    key: 'pending',
                    label: 'Submit for Approval',
                    icon: <ApproveIcon />,
                    color: 'success'
                });
                actions.push({
                    key: 'cancelled',
                    label: 'Cancel Booking',
                    icon: <CancelIcon />,
                    color: 'error'
                });
                break;

            case 'pending':
                actions.push({
                    key: 'confirmed',
                    label: 'Confirm Booking',
                    icon: <CheckCircleIcon />,
                    color: 'success'
                });
                actions.push({
                    key: 'cancelled',
                    label: 'Cancel Booking',
                    icon: <CancelIcon />,
                    color: 'error'
                });
                break;

            case 'reserved':
                actions.push({
                    key: 'confirmed',
                    label: 'Confirm Booking',
                    icon: <CheckCircleIcon />,
                    color: 'success'
                });
                actions.push({
                    key: 'cancelled',
                    label: 'Cancel Booking',
                    icon: <CancelIcon />,
                    color: 'error'
                });
                break;

            case 'confirmed':
                actions.push({
                    key: 'completed',
                    label: 'Mark as Completed',
                    icon: <CheckCircleIcon />,
                    color: 'secondary'
                });
                actions.push({
                    key: 'cancelled',
                    label: 'Cancel Booking',
                    icon: <CancelIcon />,
                    color: 'error'
                });
                break;

            case 'cancelled':
            case 'completed':
            case 'expired':
                // Only "View Details"
                break;

            default:
                break;
        }

        return actions;
    };

    const availableActions = getAvailableActions(booking.status);

    if (availableActions.length === 0) {
        return null;
    }

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                <IconButton
                    size="small"
                    onClick={handleMenuOpen}
                    disabled={availableActions.length === 0 || booking.status === 'completed' || booking.status === 'cancelled' || booking.status === 'expired'}
                    aria-label="booking actions"
                    aria-haspopup="true"
                    aria-expanded={Boolean(anchorEl)}
                    sx={{
                        width: 28,
                        height: 28,
                        '&:hover': {
                            backgroundColor: 'action.hover'
                        },
                        '&:disabled': {
                            opacity: 0.5,
                            cursor: 'not-allowed'
                        }
                    }}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </Box>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {availableActions.map((action) => (
                    <MenuItem
                        key={action.key}
                        onClick={() => handleAction(action.key)}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            minWidth: 200
                        }}
                    >
                        <Box sx={{ color: `${action.color}.main` }}>
                            {action.icon}
                        </Box>
                        <Typography variant="body2">
                            {action.label}
                        </Typography>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default BookingAction;
